<template>
  <div class="pFooter-InfinityLoad" v-if="fixed">
    <div class="pFooter-InfinityLoad_Inner">
      <!-- 上部に戻るボタン要検討 -->
      <!-- <v-btn fab dark small class="ma-2" elevation="1" color="white" @click="$vuetify.goTo(0)">
        <v-icon :color="ColorText">expand_less</v-icon>
      </v-btn>-->

      <v-menu
        close-on-content-click
        top
        offset-y
        content-class="pFooter-Menu elevation-0"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            v-bind="attrs"
            v-on="on"
            fab
            dark
            small
            class="ma-2"
            elevation="0"
            color="white"
          >
            <v-icon :color="ColorTextSub">menu</v-icon>
          </v-btn>
        </template>

        <v-list>
          <v-list-item class="px-8" dense @click="$vuetify.goTo(0)">
            <v-list-item-title>
              <v-icon>arrow_upward</v-icon>
            </v-list-item-title>
          </v-list-item>

          <v-list-item
            class="px-8"
            dense
            v-for="(item, index) in menuItems"
            :key="index"
            :href="item.url"
            target="_blank"
            rel="noopener noreferrer"
          >
            <v-list-item-title>{{ item.title }}</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
    </div>
  </div>
  <v-footer
    v-else
    class="pFooter d-flex flex-column flex-sm-row align-stretch align-sm-center justify-space-between ma-0"
  >
    <ul
      class="pFooter-List d-flex pt-2 pt-sm-0 flex-column flex-sm-row text-left px-0"
    >
      <li v-for="(item, index) in menuItems" :key="index" class="pt-2 pt-sm-0">
        <a
          class="fc-white fs-xs mx-2 sw-Link-opacity"
          :href="item.url"
          target="_blank"
          rel="noopener noreferrer"
          >{{ item.title }}</a
        >
      </li>
    </ul>
    <div class="font-weight-bold text-center fs-xs px-2 mt-4 mt-sm-0">
      <router-link class="fc-white" to="/">©アルパカコネクト</router-link>
    </div>
  </v-footer>
</template>

<script>
export default {
  name: "PortalFooter",
  data() {
    return {
      menuItems: [
        {
          title: "利用規約・ポリシー",
          url: "https://support.alpaca-connect.com/hc/ja/sections/360008942032",
        },
        {
          title: "ヘルプ",
          url: "https://support.alpaca-connect.com/hc/ja",
        },
        {
          title: "マスター・クリエイター募集",
          url: "https://alpaca-connect.com/recruitingForm",
        },
        {
          title: "お問い合わせ",
          url: "https://support.alpaca-connect.com/hc/ja/requests/new",
        },
        {
          title: "ブログ",
          url: "https://blog.alpaca-connect.com/",
        },
        {
          title: "X（Twitter）",
          url: "https://twitter.com/alpaca_connect",
        },
      ],
    };
  },

  props: {
    //フッターをfixedに切り替える
    fixed: {
      mode: Boolean,
      default: false,
    },
  },
  created() {},
  methods: {},
};
</script>

<style lang="scss" scoped>
@import "@/sass/import.scss";

.pFooter {
  display: flex;
  align-items: stretch;
  background-color: var(--gray-8) !important;

  &-Menu {
    z-index: $z-nav;
    background-color: var(--white);
    border: solid 1px var(--c-border);
  }

  &-InfinityLoad {
    // height: 80px;
    @include media($sm) {
      height: 0;
    }
    &_Inner {
      position: fixed;
      right: 4px;
      bottom: 0;
      z-index: $z-nav;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      padding: 16px 0;
    }
  }

  &-List {
    list-style: none;
  }
}
</style>
